import React, { FC, memo } from "react";
import { CheveronLink, NavContent } from "../style";
import {
  Popover,
  PopoverBody,
  PopoverContent,
  PopoverTrigger,
} from "@chakra-ui/popover";
import { Box, SimpleGrid, Link as LinkChakra } from "@chakra-ui/layout";
import { If, Then } from "react-if";
import { IDropdownMenu, IDropListItem } from "../models/type";
import theme from "@common/theme";
import { ChevronDownIcon } from "@chakra-ui/icons";
import DropListItem from "./DropListItem";
import DropItem from "./DropItem";

const DropdownMenu: FC<IDropdownMenu> = (props) => {
  const sectionItem = props.section;
  return (
    <Box>
      <Popover trigger={"hover"} placement={"bottom-start"}>
        <CheveronLink>
          <PopoverTrigger>
            <LinkChakra
              href={sectionItem.linkTo}
              color={"black"}
              px={{ base: 2, lg: 1, xl: 4 }}
              fontSize={{ md: "m", lg: "r" }}
              fontWeight={500}
              fontFamily={"heading"}
              _hover={{
                textDecoration: "none",
                color: "black",
                fontWeight: "600",
              }}
            >
              {sectionItem.text}
              {(sectionItem.dropListItem || sectionItem.dropItems) && (
                <ChevronDownIcon boxSize={6} />
              )}
            </LinkChakra>
          </PopoverTrigger>
        </CheveronLink>

        <If condition={sectionItem.dropListItem != undefined}>
          <Then>
            <PopoverContent
              border={0}
              boxShadow={"xl"}
              p={4}
              bg={theme.colors.white}
              mt={8}
              rounded={0}
              width={"100vw"}
              alignItems={"center"}
              justifyContent="space-between"
            >
              <PopoverBody userSelect="none" whiteSpace="normal">
                <NavContent aria-label="submenu">
                  <SimpleGrid columns={3} spacing={3}>
                    {sectionItem.dropListItem?.map(
                      (item: IDropListItem, index) => (
                        <DropListItem key={index} item={item} />
                      )
                    )}
                  </SimpleGrid>
                </NavContent>
              </PopoverBody>
            </PopoverContent>
          </Then>
        </If>

        <If condition={sectionItem.dropItems != undefined}>
          <Then>
            <PopoverContent
              border={0}
              boxShadow={"xl"}
              bg={theme.colors.white}
              p={4}
              mt={8}
              rounded={0}
              width={"100vw"}
              alignItems={"center"}
              justifyContent="space-between"
            >
              <PopoverBody userSelect="none" whiteSpace="normal">
                <NavContent aria-label="submenu">
                  <DropItem sectionItem={sectionItem} />
                </NavContent>
              </PopoverBody>
            </PopoverContent>
          </Then>
        </If>
      </Popover>
    </Box>
  );
};

export default memo(DropdownMenu);
